module.exports = __webpack_public_path__ + "img/banner1.b99c5516.jpg";